import styled, {css} from 'styled-components';
import { LINK, PRIMARY, BG_LIGHT_BLUE } from '../../shared/styles/colors';
import { flexBox, fontSize } from '../../shared/styles/mixins'
import { Button } from '@material-ui/core'
import { Link } from '@reach/router';

const DefaultLinkStyle = `
  font-size: 15px;
  font-weight: normal;
  line-height: 2.67;
  color: ${PRIMARY};
  display: block;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export const NavButton = styled(Button)`
  &.MuiButton-outlinedSizeSmall {
    text-align: center;
    width: 145px;
    font-size: .75rem;
    font-weight: 400;
    margin-bottom: 0;
    height: 24px;
  }
`;

export const TopHeader = styled.section`
  background-color: ${BG_LIGHT_BLUE};
  height: 40px;
  width: 100%;
  ${flexBox('row', 'flex-start')};
  padding: 0 0 0 4.88%;
  position: relative;
  @media (min-width: 1280px) {
    justify-content: center;
    padding: 0;
  }
`;

export const LinkList = styled.ul`
  display: flex;
  align-items: center;
  ${({tosites}) => tosites && css`
    width: 20%;
    min-width: 342px;
    justify-content: space-between;
    li {
      width: 49%;
      padding: 0;
    }
    @media (max-width: 1280px) {
      width: 100%;
      justify-content: flex-start;
      li {
        width: unset;
        margin-right: 20px;
      }
    }
    @media (max-width: 600px) {
      width: 100%;
      justify-content: space-evenly;
      li {
        width: 49%;
      }
    }
  `}
`;

export const Item = styled.li`
  cursor: pointer;
  ${fontSize(12)};
  color: ${LINK};
  padding: ${({ padding = '0 4px' }) => padding};
  position: relative;
  height: 40px;
  ${flexBox()};
  ${({active}) => (active && css`border-bottom: 2px solid #FE3E64`)};

  @media (min-width: 1028px) {
    ${fontSize(14)};
  }

  & > a.active {
    font-weight: 600;
  }

  ${({ divider }) => divider && `
    &:after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      right: -1px;
      height: 100%;
      width: 1px;
      background-color: ${LINK};
    }
  `}
`;

export const TopContent = styled.section`
  margin: auto;
  width: 1012px;
  display: flex;
  justify-content: space-between;
  @media (max-width: 1280px) {
    width: 100%;
    justify-content: space-evenly;
  }
`
export const InternalLink = styled(Link)`
  ${DefaultLinkStyle}
`;

export const ExternalLink = styled.a`
  ${DefaultLinkStyle}  
`;